<template>
    <v-flex fill-height>
        <sidemainmenu></sidemainmenu>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-form>
                    <v-flex>
                        <v-layout>
                            <v-flex>
                                <v-btn block color="warning" v-on:click="seen = !seen">Add New<v-icon right dark>add</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-form>
            </v-card-title>
            <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
            </v-alert>
            <v-alert :value="alerterror" color="error" icon="new_releases">
                <ul>
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </v-alert>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        State Master
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="state" :search="search">
                        <template v-slot:items="props">
                            <td>{{ props.item.id }}</td>
                            <td class="text-xs-right">{{ props.item.name }}</td>
                            <td class="text-xs-right">{{ props.item.code }}</td>
                            <td class="text-xs-right">{{ props.item.tax_code }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-card-title>Add New State
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="mx-auto">
                        <v-form ref="form">
                            <v-text-field v-model="txtstatename" label="State Name" required :rules="[(v) => !!v || 'State Name is required']"></v-text-field>
                            <v-text-field v-model="txtstatecode" label="State Code" required :rules="[(v) => !!v || 'State Code is required']"></v-text-field>
                            <v-text-field v-model="txtstatetaxcode" label="Tax Code" required :rules="[(v) => !!v || 'Tax Code is required']"></v-text-field>
                            <v-btn color="success"  v-on:click="submitData()">Save</v-btn>
                            <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus></bottomfootermenus>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'state',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            state: [],
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtstatename: null,
            txtstatecode: null,
            txtstatetaxcode: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', align: 'left', value: 'id' },
              { text: 'State Name', align: 'right', value: 'name' },
              { text: 'State Code', align: 'right', value: 'code' },
              { text: 'Tax Code', align: 'right', value: 'tax_code' }
            ],
        }
    },
    mounted:function(){
        this.getData()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/masters/state"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.state = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const data = {'crossDomain': true,
                          'name': this.txtstatename,
                          'code': this.txtstatecode,
                          'tax_code': this.txtstatetaxcode,
                          'created_by': localStorage.username}
            axios.post(this.$hostname + '/masters/state', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    this.alertsmessage = response.data.message;
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = true;
                    this.errors = error.response.data.error;
                })
        },
        clearData: function() {
            this.txtunitname = null;
            this.txtunitcode = null;
        }
    }
  }
</script>
